import gmrfidCode from './gmrfidCode'

export default function getStatusName(key, name) {
  let str = ''
  switch (key) {
    // case 'NO_START':
    //   str = '未开始'
    //   break
    // case 'PROCESSING':
    //   str = '进行中'
    //   break
    // case 'STOP':
    //   str = '已停止'
    //   break
    // case 'END':
    //   str = '已结束'
    //   break
    case Object.keys(gmrfidCode[name]).find(item => item === key):
      str = gmrfidCode[name][key]
      break
    default:
      break
  }
  return str
}
